import { GetCustomerForecastRateResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/customerForecastManage';
import { IForecastAccuracyRateResult } from '../domains/entities/forecastAccuracyRateResult';
import { UserAccount } from '@/coreDomainsModule/entities/users';

/**
 * 内示正答率取得のアダプタ
 */
export class GetForecastAccuracyRateAdapter {
  /**
   * responseをUI用に変換する
   * @param response - APIレスポンス
   */
  public static adaptForResponse(response: GetCustomerForecastRateResponseAllOfResult): IForecastAccuracyRateResult {
    return {
      data: (response.data || []).map((item) => ({
        forecastForReceiptId: item.forecastForReceiptId,
        forecastForReceiptName: item.forecastForReceiptName,
        forecastForReceiptResponsibleUsers: (item.forecastForReceiptResponsibleUsers || []).map(
          (user): UserAccount => ({
            name: user.name,
            email: undefined,
            organizationId: undefined,
            role: undefined,
            profile: undefined,
            createdAt: undefined,
            updatedAt: undefined,
          })
        ),
        previousMonthSalesResult: item.previousMonthSalesResult,
        previousMonthForecast: item.previousMonthForecast,
        previousMonthAccuracyRate:
          item.previousMonthForecast && item.previousMonthForecast > 0
            ? Math.round((item.previousMonthSalesResult / item.previousMonthForecast) * 100)
            : null,
        customerForecasts:
          item.monthlyAccuracy?.map((monthly) => ({
            targetYear: monthly.targetYear,
            targetMonth: monthly.targetMonth,
            amount: monthly.accuracyRate, // accuracyRate is the calculated value (or null)
          })) || [],
        isVirtualChild: false,
      })),
      pagingOptions: {
        pageSize: response.pagingOptions?.pageSize || 0,
        offset: response.pagingOptions?.offset || 0,
        returnCount: response.pagingOptions?.returnCount || 0,
        totalResultsAvailable: response.pagingOptions?.totalResultsAvailable,
      },
    };
  }
}
